<template>
  <div class="participation is--full-detail-width-small">
    <div v-if="props.title" class="participation-title" v-html="props.title"></div>

    <Alinea
      v-if="props.text && props.text.blocks"
      variant="body"
      text-style="inverted"
      :blocks="props.text.blocks"
      class="participation-text"
    />

    <div class="participation-button">
      <Button
        label="Doe ook mee"
        to="/doe-mee"
        variant="primary"
        type="cta"
        icon="eenvandaag-general:arrow-right"
        icon-position="right"
        :analytics="{ linkAnalyticsTag: 'content-participation' }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ICmsContentParticipationBlocks } from '~~/types/_cms-types';

interface IProps extends ICmsContentParticipationBlocks {
  text?: { blocks: Array<never> };
  title?: string;
}

const props = withDefaults(defineProps<IProps>(), {
  title: undefined,
  text: undefined,
});
</script>

<style lang="postcss" scoped>
.participation {
  --participation-gradient: var(--effect-gradient-primary-2);
  --participation-gap: var(--unit-8);
  --participation-padding: var(--unit-24) var(--unit-24) var(--unit-32) var(--unit-24);

  position: relative;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  background: var(--participation-gradient);
  color: hsl(var(--color-neutral-white));
  padding: var(--participation-padding);
  justify-content: flex-end;
  align-items: flex-start;
  gap: var(--participation-gap);

  &::before {
    content: '';
    height: 100%;
    width: 100%;
    bottom: 0;
    left: 0;
    position: absolute;
    background: url('/assets/images/pattern.png') repeat;
    background-size: 130px 130px; /* FIXED SIZE */
    mask-position: center top;
    mask-repeat: no-repeat, no-repeat;
    mask-image: linear-gradient(0deg, #000 0.13%, rgba(0, 0, 0, 0.2) 99.13%);
    opacity: 0.5;
  }

  @media (--lg-viewport) {
    --participation-padding: var(--unit-32) var(--unit-48) var(--unit-40) var(--unit-32);
    --participation-gap: var(--unit-8);
  }
}

.participation-title {
  color: hsl(var(--color-accent-bright-blue));
  position: relative;
  word-break: break-word;

  @add-mixin heading-xl;
}

.participation-text {
  position: relative;

  &:deep(.paragraph) {
    color: hsl(var(--color-neutral-white));
  }
}

.participation-button {
  --participation-button-margin: var(--unit-8) 0 0 0;

  position: relative;
  margin: var(--participation-button-margin);

  @media (--lg-viewport) {
    --participation-button-margin: var(--unit-12) 0 0 0;
  }
}
</style>
